let IS_PROD = true;
let server = IS_PROD
  ? "https://sahil-zoom-backend.onrender.com"
  : "http://localhost:8000";

export default server;
